export default __webpack_public_path__ + "static/media/send.7a789a0c.svg";